import { BenefitsListPage } from '../@types/benefitsListPage';
import { WELCOME_MODAL } from '../domain/routes';

export const getShouldRefetchProductsAndEntitlements = ({
  benefitsPage,
  hasMieterPlus,
  hasWohnenPlus,
  hasSuccessSearchParam,
  nestedPath,
  areProductsLoading,
}: {
  hasMieterPlus: boolean;
  hasWohnenPlus: boolean;
  hasSuccessSearchParam: boolean;
  areProductsLoading: boolean;
  nestedPath: string | null;
  benefitsPage: BenefitsListPage;
}) => {
  if (areProductsLoading) return false;
  if (nestedPath !== WELCOME_MODAL) return false;
  if (benefitsPage === BenefitsListPage.KauferPlus) return false;
  const shouldRefetchForWohnenPlus =
    benefitsPage === BenefitsListPage.MieterPlus && !hasMieterPlus && hasSuccessSearchParam;
  const shouldRefetchForMieterPlus =
    benefitsPage === BenefitsListPage.WohnenPlus && !hasWohnenPlus && hasSuccessSearchParam;
  return shouldRefetchForMieterPlus || shouldRefetchForWohnenPlus;
};
